import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import AuthComponent from "./auth/authComponent";
import { OnboardingGuard } from "@/features/onboarding";

import { RouterProvider } from "react-router-dom";
import { useLoadingStore } from "./shared/stores";

import { AppBackground, ContentContainer } from "./styles";
import { router } from "./routes";
import { LoadingSpinner, Toast } from "./shared/components";
import { useQueryLoading, useMasterData } from "./shared/hooks";
import { useIdleGlobal } from "./shared/hooks/useIdleGlobal";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      staleTime: 5 * 60 * 1000, // 5 minutos
    },
  },
});

export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AppWithQueryClient />
      <Toast />
    </QueryClientProvider>
  );
};

const AppWithQueryClient = () => {
  // Inicializar sistema de idle global
  useIdleGlobal();

  // Usar React Query para detectar loading global automáticamente
  const { isLoading: isQueryLoading } = useQueryLoading();
  const isStoreLoading = useLoadingStore((state) => state.isAnyLoading());

  // Combinar loading de React Query + store manual
  const isAnyLoading = isQueryLoading || isStoreLoading;

  return (
    <>
      <LoadingSpinner
        isLoading={isAnyLoading}
        message="Cargando datos..."
        delay={200}
      />
      <AuthComponent>
        <AuthenticatedApp />
      </AuthComponent>
    </>
  );
};

const AuthenticatedApp = () => {
  // Cargar datos maestros solo después de autenticación
  useMasterData();

  return (
    <AppBackground>
      <ContentContainer>
        <OnboardingGuard>
          <RouterProvider router={router} />
        </OnboardingGuard>
      </ContentContainer>
    </AppBackground>
  );
};
